import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  private readonly config = (window as any)['__env'] || {};

  get googleApiKey(): string {
    return this.config.googleApiKey;
  }
}